export default __webpack_public_path__ + "static/review-4-3dc48a342669f92bb2f1ef6d546c23ee.png";